<div class="content-wrapper">
    <div class="content-body">
        <section id="product">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title" *ngIf="modalType === 'CART_CONFORMATION'">Conformation : Cart Clear</h4>
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'PRODUCT_DETAILS'">Product Detail - {{selectedProduct?.name}}</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row p-10px" *ngIf="modalType === 'PRODUCT_DETAILS'">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h5>
                                    {{selectedProduct?.description}}
                                </h5>
                            </div>
                        </div>
                        <div class="row p-10px" *ngIf="modalType === 'CART_CONFORMATION'">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h4>
                                    <span class="text-italic font-weight-bold">
                                        Your cart have Another Stockist Product.
                                    </span>
                                    Are you sure you want to permanently remove all Items from Your cart ?
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer p-10px">
                        <button class="btn btn-sm btn-primary color-white" (click)="modalService.dismissAll('')" *ngIf="modalType === 'PRODUCT_DETAILS'">
                            <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Ok
                        </button>
                        <button class="btn btn-sm btn-danger color-white" (click)="clearCartItem()" *ngIf="modalType === 'CART_CONFORMATION'">
                        <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure
                    </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Products</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3 mb-2" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-10 col-lg-10 col-sm-10 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12"></div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="stockistFilterForm">
                        <select class="form-control mt-10px" formControlName="stockist_id" (change)="get()">
                            <option value="">Choose Stockist</option>
                            <option [value]="stockist.unique_id" *ngFor="let stockist of stockists">{{stockist?.name}} ({{stockist?.username}})</option>
                        </select>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="row p-10px" *ngIf="products && products.length > 0; else noDataToShow">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12"
                             *ngFor="let product of products; let i = index">
                            <div class="card shadow-5px">
                                <div class="card-header">
                                    <img [src]="imageBaseUrl+product?.image?.partial_url" width="100%" height="300px" [alt]="product?.name"/>
                                </div>
                                <div class="card-body">
                                    <div class="row text-center">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <h4>{{product?.name}}</h4>
                                        </div>
                                    </div>
                                    <div class="row text-center">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <h3>
                                                <span class="text-success font-weight-bold font-italic">
                                                    &#8377;{{product?.product?.current_distributed_price | IndianNumber}}
                                                </span>
                                                <!--<span class="f_13 text-strike">
                                                    &#8377;{{product?.product?.current_mrp | IndianNumber}}
                                                </span>-->
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="row text-center mt-10px text-italic">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <h6>
                                                Quantity Available
                                            </h6>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                            <h6>
                                                {{product?.quantity | IndianNumber}}
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="row text-center mt-10px text-italic">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <h6>
                                                Business Volume
                                            </h6>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                            <h6>
                                                {{product?.product?.current_basic_value | IndianNumber}}
                                            </h6>
                                        </div>
                                    </div>
                                    <div class="row shadow-top-light mt-10px">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <button class="btn btn-sm btn-primary p-8px mt-15px"
                                                    title="View Product Details"
                                                    (click)="viewProductDetail(content, product)">
                                                <i class="fa fa-info-circle fa-2x" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                            <button class="btn btn-sm btn-primary p-8px mt-15px" title="Add to Cart"
                                                    (click)="addToCart(content,product)" *ngIf="!product['added_to_cart']">
                                                <i class="fa fa-cart-plus fa-2x" aria-hidden="true"></i>
                                            </button>
                                            <button class="btn btn-sm background-blue p-8px mt-15px" title="Remove from Cart"
                                                    (click)="removeFromCart(product)" *ngIf="product['added_to_cart']">
                                                <i class="fa fa-cart-plus fa-2x color-white" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #noDataToShow>
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="card shadow-5px">
                                    <div class="card-body text-italic text-center">
                                        <i class="fa fa-shopping-cart fa-4x" aria-hidden="true"></i>
                                        <h5 class="p-20px">Choose Stockist to view products</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </section>
    </div>
</div>
